import React, { useState, useEffect, useContext } from 'react';
import { Form } from 'react-bootstrap';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { useLocation } from "react-router-dom";
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { AuthContext } from '../context/AuthContext';

const UpdateAddress = ({ open, onClose, onUpdate, currentaddress }) => {
    const location = useLocation();
    const initialAddress = location.state?.address || currentaddress || '';
    const [address, setAddress] = useState(initialAddress);
    const [errors, setErrors] = useState({ address: '' });
    const [loading, setLoading] = useState(false);
    const { updateUserData } = useContext(AuthContext)

    useEffect(() => {
        // Update `name` state whenever `currentname` prop changes
        if (currentaddress) {
            setAddress(currentaddress);
        }
    }, [currentaddress]);

    const handleAddressSubmit = async (event) => {
        event.preventDefault();

        let newErrors = { ...errors };

        if (!address) {
            console.log('no email');
            newErrors.address = 'Address is required.';
        } else {
            newErrors.address = '';
        }

        setErrors(newErrors);

        // If there are no errors, close the dialog
        if (!newErrors.address) {
            setLoading(true);

            try {
                await updateUserData('address', address); 
                onClose(); // Close the dialog on success
                onUpdate("address", address); 
            } catch (error) {
                console.error("Error updating name:", error);
                // Handle error if needed
            } finally {
                setLoading(false);
            }
        }
    };

    return(
        <Dialog open={open} onClose={onClose} aria-labelledby="settings-dialog-title" fullWidth PaperProps={{
            style: {
              width: '480px',
              maxWidth: '100%',
            },
          }} className="setting-dialog">
            <DialogTitle id="settings-dialog-title" className="d-flex justify-content-between mb-4">
                <div className="d-flex align-items-center">
                    <img style={{ float: 'none', height: "20px", width: "18px" }} src={`${process.env.PUBLIC_URL}/images/left.svg`} alt="left" className="close-icon" role="button" 
                    onClick={() => {
                        onClose();
                    }} />
                    <span style={{marginLeft:"10px"}}>Update Address</span>
                </div>
              <img style={{ float: 'none', height: "22px", width: "20px" }} src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={onClose} />
            </DialogTitle>
            <DialogContent>
                <Form onSubmit={handleAddressSubmit}>
                    <div className="mb-2">
                        <span style={{fontSize: "16px"}}>Address</span>
                    </div>
                    <Form.Group controlId="formBasicEmail" className="control">
                        <FormControl className="square-form-control-update m-0" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                placeholder=" "
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                fullWidth
                                margin="normal"
                                type="text"
                                // multiline
                                // // maxRows={4}
                                // InputProps={{
                                //     style: { color: "#898889", border:'1px solid #48494C' } // Text color inside the TextField
                                // }}
                            />
                        </FormControl>
                    </Form.Group>
                    {errors.address && <div className="text-danger mt-1">{errors.address}</div>}
                    
                    <div className="mt-2 mb-3 row justify-content-center">
                        <Button variant="primary" type="submit" style={{backgroundColor: '#317CFF', textTransform: 'none'}} className="mt-5 w-55 p-2 theme-btn-email" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </Button>
                    </div>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

export default UpdateAddress;